import React from 'react';
import {useQuickViewVariant} from './useQuickViewVariant';

interface QuickViewHandlerProps {
  page: React.ReactNode;
  quickViewPage: React.ReactNode;
  quickViewV2Page: React.ReactNode;
}

export const QuickViewHandler: React.FC<QuickViewHandlerProps> = ({
  page,
  quickViewPage,
  quickViewV2Page,
}) => {
  const variant = useQuickViewVariant();

  if (variant === 'quickViewV2') {
    return (
      <>
        {quickViewV2Page}
        <span data-quick-view-enabled="true" data-quick-view-variant="v2" />
      </>
    );
  }

  if (variant === 'quickView') {
    return (
      <>
        {quickViewPage}
        <span data-quick-view-enabled="true" data-quick-view-variant="v1" />
      </>
    );
  }

  return (
    <>
      {page}
      <span data-quick-view-enabled="false" data-quick-view-variant="adp" />
    </>
  );
};
